import React from 'react';
import './App.css';
import 'typeface-roboto/index.css';
import Home from './pages/Home';
import StateLoader from './scaffolding/StateLoader';

export default function App(props) {
  return <StateLoader><Home /></StateLoader>;
}
